import {connect} from "react-redux";

export default function addHoverData(WrappedComponent) {
    return connect(
        // While it would be possible to access the parent {isSelected} straight
        // from this map fn, it unfortunately disables "pure" component behaviour
        // in the current @connect implementation :( Hence the mergeProps fn below.
        ({tooltip})=> ({
            hoveredItem: tooltip.contents
        }),
        null,
        ({hoveredItem}, dispatchProps, parentProps) => ({
            ...parentProps,
            hoveredItem: parentProps.isSelected ? hoveredItem : null
        })
        , {withRef: true}
    )(WrappedComponent);
}



// WEBPACK FOOTER //
// ./src/kpi/common/HoverData.js